import React, { useState, useEffect } from "react";
import HeroSectionV2 from "../../../components/HeroSectionV2";
import Billede1 from "../../../Images/Billede1.jpg";
import FriviligeList from "./FriviligeList";
import { User } from "./types";
import { useNavigate } from "react-router-dom";
import "../../../Layouts/buttons.css";
import "../../../Layouts/table.css";

const FriviligePage: React.FC = () => {
    const apiUrl = process.env.REACT_APP_API_URL as string;

    const [volunteers, setVolunteers] = useState<User[]>([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const pageSize = 50;

    const fetchJsonSafe = async (url: string, options?: RequestInit) => {
        try {
            const res = await fetch(url, options);
            if (!res.ok) throw new Error(await res.text());
            return res.headers.get("content-type")?.includes("application/json") ? await res.json() : null;
        } catch (err) {
            console.error("Fetch error:", err);
            return null;
        }
    };

    // Fetch volunteers linked to current user's events
    const fetchVolunteers = async () => {
        const currentUserId = sessionStorage.getItem("userId");
        if (!currentUserId) return;

        const data = await fetchJsonSafe(`${apiUrl}/api/users/${currentUserId}/volunteers`);
        if (!data) return;

        setVolunteers(data);
        setPage(1); // Reset pagination on new fetch
    };

    useEffect(() => {
        fetchVolunteers();
    }, []);

    const navigate = useNavigate();

    // ------------------ Impersonate volunteer ------------------
    const handleLoginAsUser = async (user: User) => {
        console.log("Volunteer user clicked:", user);

        const adminToken = sessionStorage.getItem("authToken");
        if (!adminToken) return alert("Du skal være logget ind som admin først!");
        if (!window.confirm(`Vil du logge ind som ${user.email}?`)) return;

        try {
            const res = await fetch(`${apiUrl}/api/users/impersonate/${user.userId}`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${adminToken}`
                }
            });

            const rawText = await res.text();
            console.log("Impersonate response status:", res.status);
            console.log("Impersonate response body:", rawText);

            if (!res.ok) {
                return alert("Fejl ved login som bruger: " + rawText);
            }

            const data = JSON.parse(rawText);

            [
                "authToken",
                "userId",
                "personId",
                "username",
                "userEmail",
                "avatarUrl",
                "phone",
                "firstName",
                "requireProfileUpdate",
                "userRoles"
            ].forEach(k => sessionStorage.removeItem(k));

            sessionStorage.setItem("authToken", data.token);
            sessionStorage.setItem("userId", String(data.userId));
            sessionStorage.setItem("personId", String(data.personId));
            sessionStorage.setItem("username", `${data.firstName ?? ""} ${data.lastName ?? ""}`.trim());
            sessionStorage.setItem("userEmail", data.email || "");
            sessionStorage.setItem("firstName", data.firstName || "");
            sessionStorage.setItem("avatarUrl", "");
            sessionStorage.setItem("phone", "");
            sessionStorage.setItem("requireProfileUpdate", "0");

            sessionStorage.setItem(
                "userRoles",
                JSON.stringify(data.userRoles?.map((r: any) => r.roleName) || [])
            );

            window.dispatchEvent(new Event("auth-changed"));
            navigate("/UserDashboard");
        } catch (err) {
            console.error("Impersonation failed", err);
            alert("Fejl ved login som bruger.");
        }
    };

    // -------------------- Local search + pagination --------------------
    const filteredVolunteers = volunteers.filter(v =>
        (v.firstName ?? "").toLowerCase().includes(search.toLowerCase()) ||
        (v.lastName ?? "").toLowerCase().includes(search.toLowerCase()) ||
        (v.email ?? "").toLowerCase().includes(search.toLowerCase())
    );

    const paginatedVolunteers = filteredVolunteers.slice(
        (page - 1) * pageSize,
        page * pageSize
    );

    return (
        <div>
            <HeroSectionV2
                titleEn="Volunteers"
                titleDa="Frivillige"
                descriptionEn=""
                descriptionDa="Se alle frivillige"
                imageSrc={Billede1}
            />

            <div className="user-admin-page">
                <div className="search-panel">
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Søg efter brugere..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                        <button onClick={() => setPage(1)} className="btn btn--new">
                            Søg
                        </button>
                    </div>
                </div>

                <FriviligeList
                    volunteers={paginatedVolunteers}
                    onLoginAs={handleLoginAsUser}
                />

                {filteredVolunteers.length > pageSize && (
                    <div className="pagination">
                        <span>
                            Side {page} af {Math.ceil(filteredVolunteers.length / pageSize)}
                        </span>
                        <div>
                            <button
                                onClick={() => setPage(p => Math.max(1, p - 1))}
                                className="btn btn--function"
                                disabled={page === 1}
                            >
                                Forrige
                            </button>
                            <button
                                onClick={() =>
                                    setPage(p => Math.min(Math.ceil(filteredVolunteers.length / pageSize), p + 1))
                                }
                                className="btn btn--default"
                                disabled={page >= Math.ceil(filteredVolunteers.length / pageSize)}
                            >
                                Næste
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FriviligePage;